import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchCaseReport } from '../../../utilities/API/caseServices'

export const getCaseReport = createAsyncThunk(
    'case/reports', fetchCaseReport
)


const initialState = {
    loader: false,
}

const caseReportsSlice = createSlice({
    name: 'getReports',
    initialState,

    reducers: {
       
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCaseReport.pending, (state, action) => {
                state.loader = true
            })
            .addCase(getCaseReport.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(getCaseReport.rejected, (state, action) => {
                state.loader = false
            })
    },
})

export default caseReportsSlice.reducer
